// extracted by mini-css-extract-plugin
export default {"container":"header_container__D71yz","logo":"header_logo__1vlxc","navDiv":"header_navDiv__4YwQ9","notificationDiv":"header_notificationDiv__Cu9Z+"};